import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { MainContext } from './models/MainContext'
import { createBrowserRouter, Link, RouterProvider } from 'react-router-dom'
import Layout from './components/shared/Layout'
import LandingPage from './pages/LandingPage'
import "./scss/index.scss"
import { LOADER_OPTIONS } from './models/LoaderModel'
import { RoutesEnum } from './models/RoutesModel'
import { ProjectTypeEnum, ThemeTypes } from './models/SharedModel'
import DocumentAIPage from './projects/document_ai/components/DocumentAIPage'
import DataAnalyticsPage from './projects/data_analytics/components/DataAnalyticsPage'
import { getFromSession, setToSession } from './helpers/GenericHelpers'
import LoginPage from './pages/LoginPage'
import ProtectedRoute from './components/auth/ProtectedRoute'
import NotFoundPage from './pages/NotFoundPage'
import Service from './services'
import { getAllLogs, pushAllLogs } from './helpers/LogHelpers'
import ResearchInsightsPage from './projects/research_insights/components/ResearchInsightsPage'
import Solutionstudio from './projects/SolutionsStudio/components/Solutionstudio'
import SignUp from './pages/SignUp'
import WorkSpacePage from './components/workspace/WorkSpacePage'
import { ThemeContext } from './models/ThemeContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoon, faSun } from '@fortawesome/free-solid-svg-icons'
import EbookInsightsPage from './projects/ebook_insights/components/EbookInsightsPage'
import AdminSettings from './pages/AdminSettings'

const App = () => {
  const service = new Service();

  // states
  const [ loadersList, setLoadersList ] = useState<string[]>([]);
  const [ themeName, modifyTheme ] = useState<string>(ThemeTypes.BLUE_THEME);

  const [init, setInit] = useState(true);
  
  // helpers
  const modifyLoaders = (value: string, type: LOADER_OPTIONS) => {
    if (type === LOADER_OPTIONS.ADD) {
      setLoadersList(prev => ([...prev, value]))
    } 
    if (type === LOADER_OPTIONS.REMOVE) {
      setLoadersList(prev => prev?.filter(each => each !== value))
    }
  }

  // apis
  const get_frontend_logs = () => {
    service.get_frontend_logs()
      .then(res => {
        pushAllLogs(res?.data)
        setInit(false)
      })
      .catch(err => console.log(err))
  }

  const save_frontend_logs = () => {
    const data = getAllLogs()
    console.log("length")
    console.log(data?.length)
    const filteredData = data.slice(Math.max(data.length - 500, 0))
    service.save_frontend_logs(filteredData)  
      .catch(err => console.log(err))
  }

  // useEffects

  // Todo: remove this useeffect after login setup
  useEffect(() => {
    const user_name = getFromSession('user_name')
    const user_id = getFromSession('user_id')
    if (!user_id && user_name) {
      setToSession('user_id', user_name)
    }
    if (init) {
      get_frontend_logs()
    }
  }, [])

  useEffect(() => {
    const interval = setInterval(() => save_frontend_logs(), 3000 * 60)
    return () => clearInterval(interval)
  }, [])
  
  // router 
  const router = createBrowserRouter([
    {
      path: RoutesEnum.LOGIN,
      element: <LoginPage />,
    },
    {
      path: RoutesEnum.SIGNUP,
      element: <SignUp />,
    },
    {
      path: '',
      element: <ProtectedRoute />,
      children: [
        {
          path: `${RoutesEnum.ALL}`,
          element: <Layout />,
          children: [
            {
              path: '',
              element:  <LandingPage />,
            },
            {
              path: `${RoutesEnum.LANDING}`,
              element:  <LandingPage />,
              children: [ {path: ':tab' }]
            },
            {
              path: `${RoutesEnum.ADMIN_SETTINGS}`,
              element:  <AdminSettings />,
            },
            // { path: `${RoutesEnum.WORK_SPACE}` , element:  <WorkSpacePage />},
            {
              path: `:projectName`,
              children: [
                // { path: `${ProjectTypeEnum.DOCUMENT_AI}/:version` , element:  <DocumentAIPage /> },
                { path: `${ProjectTypeEnum.DOCUMENT_AI}/:version` , element:  <Solutionstudio />},
                { path: `${ProjectTypeEnum.DATA_ANALYTICS}/:version` , element:  <DataAnalyticsPage /> },
                { path: `${ProjectTypeEnum.RESEARCH_INSIGHTS}/:version` , element:  <ResearchInsightsPage /> },
                { path: `${ProjectTypeEnum.EBOOK__INSIGHTS}/:version` , element:  <EbookInsightsPage /> },
                // { path: ProjectTypeEnum.AI_TOOLS , element:  <AIToolsPage /> },
              ]
            },
            {
              path: RoutesEnum.NOT_FOUND,
              element: <NotFoundPage />,
            }    
          ]
        },
      ]
    },
  ]);

  const changeTheme = () =>{
    if(themeName=== ThemeTypes.DARK_THEME){
      modifyTheme(ThemeTypes.BLUE_THEME)
    }else{
      modifyTheme(ThemeTypes.DARK_THEME)
    }
  }

  return (
    <div>
      <button className="floating-button" onClick={()=>changeTheme()}>{themeName=== ThemeTypes.DARK_THEME ? <FontAwesomeIcon icon={faMoon} /> : <FontAwesomeIcon icon={faSun} />}</button>
      <MainContext.Provider
        value={{
          loadersList: loadersList,
          modifyLoaders: modifyLoaders
        }}
      >
      <ThemeContext.Provider 
        value={{
          themeName: themeName,
          modifyTheme: modifyTheme,
        }}>
        <RouterProvider router={router} />
      </ThemeContext.Provider>
      </MainContext.Provider>
      <ToastContainer />
    </div>
  )
}

export default App;
